import { isNativePush } from "@/lib/is-platform"

export default () =>
  isNativePush ||
  !!(navigator?.serviceWorker && window.PushManager && window.Notification)
